export default __webpack_public_path__ + "static/media/bigLogo.c3f02e73.svg";